// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import vueTouch from 'kim-vue-touch';// 移动端事件的封装
import FastClick from 'fastclick';
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(vueTouch);

Vue.use(ElementUI);
Vue.use(Vant);
/**
 * 处理移动端click事件300毫秒延迟。
 */
FastClick.attach(document.body);
/*
 *UI 框架的引入
 * */
import MintUI from 'mint-ui';
import {InfiniteScroll} from 'mint-ui';
import 'mint-ui/lib/style.css'
Vue.use(MintUI).use(InfiniteScroll);

// import { Row, Col,CellGroup ,Cell,Icon,Dialog,Button,Field,RadioGroup,Radio, Checkbox, CheckboxGroup ,Actionsheet,Popup,Uploader,Toast,swipe,SwipeItem,SwipeCell} from 'vant';
// Vue.use(Row).use(Col).use(Cell).use(CellGroup).use(Dialog).use(Button).use(Field).use(RadioGroup).use(Radio).use(Checkbox).use(CheckboxGroup).use(Actionsheet).use(Popup).use(Icon).use(Uploader).use(Toast).use(swipe).use(SwipeItem).use(SwipeCell);

Vue.config.productionTip = false;
/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
export default vue


// WEBPACK FOOTER //
// ./src/main.js